<mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
  <span class="font-size-16 font-weight-400">
    {{ 'LOCATIONS_GROUPS.FILTERS.TITLE' | translate }}
  </span>
</mat-toolbar>

<form class="filter-content" [formGroup]="filtersForm" fusePerfectScrollbar>
  <input
    class="mt-4 input-legacy"
    formControlName="name"
    name="text"
    placeholder="{{ 'LOCATIONS_GROUPS.FILTERS.NAME' | translate }}"
  />

  <mat-divider class="mt-16"></mat-divider>

  <div class="filter-subtitle mt-16">
    {{ 'LOCATIONS_GROUPS.FILTERS.SITUATION' | translate }}
  </div>

  <mat-form-field class="mt-16 w-100-p" appearance="legacy">
    <mat-select formControlName="archived">
      <mat-option [value]="false">
        {{ 'LOCATIONS_GROUPS.FILTERS.ACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="true">
        {{ 'LOCATIONS_GROUPS.FILTERS.INACTIVE' | translate }}
      </mat-option>
      <mat-option [value]="''">
        {{ 'LOCATIONS_GROUPS.FILTERS.ALL' | translate }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</form>
